import React, { useEffect, useState } from "react";
import { fetchDrawingImage } from "../utils/drawingAnswerApi";

// The server-rendered drawing, fetched with the signed-in user's token and
// shown from a local object URL. `revisionKey` reloads it after a change.
export default function DrawingEvidenceImage({ attemptId, questionId, version, revisionKey, alt = "Drawing answer", className }) {
  const [source, setSource] = useState("");
  const [failed, setFailed] = useState(false);

  useEffect(() => {
    if (!attemptId || !questionId) return undefined;
    let active = true;
    let objectUrl = "";
    setSource("");
    setFailed(false);
    fetchDrawingImage({ attemptId, questionId, version })
      .then((blob) => {
        if (!active) return;
        objectUrl = URL.createObjectURL(blob);
        setSource(objectUrl);
      })
      .catch(() => { if (active) setFailed(true); });
    return () => {
      active = false;
      if (objectUrl) URL.revokeObjectURL(objectUrl);
    };
  }, [attemptId, questionId, version, revisionKey]);

  if (failed) return <p className="eq-drawing-image-status" role="status">The drawing could not be loaded.</p>;
  if (!source) return <p className="eq-drawing-image-status" role="status">Loading drawing…</p>;
  return <img src={source} alt={alt} className={className} />;
}
